import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  getConciergeToken,
  clearConciergeToken,
  conciergeCmsMe,
} from "../../../../utils/conciergeCmsAuth";

const ConciergeUserAuthCtx = createContext(null);

export function ConciergeUserAuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [ready, setReady] = useState(false);

  const reload = async () => {
    const token = getConciergeToken();
    if (!token) {
      setMe(null);
      setReady(true);
      return;
    }

    try {
      const data = await conciergeCmsMe();
      setMe(data);
    } catch {
      clearConciergeToken();
      setMe(null);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => { reload(); }, []);

  const logout = () => {
    clearConciergeToken();
    setMe(null);
  };

  const value = useMemo(() => ({ me, ready, reload, logout }), [me, ready]);
  return <ConciergeUserAuthCtx.Provider value={value}>{children}</ConciergeUserAuthCtx.Provider>;
}

export function useConciergeUserAuth() {
  return useContext(ConciergeUserAuthCtx);
}

